import React, {Component} from "react";
import NavigationBar from "../presentational/NavigationBar";
import ContactFormContainer from './ContactFormContainer';

class AppContainer extends Component {
	render() {
		return (
			<div className="main-container">
				<NavigationBar ref="navbar" />
				<div id="content">{ this.props.children }</div>
				<ContactFormContainer />
			</div>
		)
	}
}

export default AppContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/AppContainer.jsx
 **/